
import React from "react";

// reactstrap components

// core components

import ModalForm from "../components/modal/modal"
import Tform from "../components/TicketForms/Tktviewform"
import UserTform from "../components/TicketForms/EndUser-ViewTktform.js"

import AuthService from "../services/auth.service"



class OutsideTKT extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        outsidetktview:this.props.match.params.tktid,
     userisagent:AuthService.getCurrentUser().roles.includes('ROLE_AGENT')
    };
  }




 openModal = () => this.setState({ isOpen: true });
closeModal = () => {window.location.href = "/";}

  
  render() {
    return (
      <>


        { this.state.userisagent   ? 
          <ModalForm 
            closeModal={this.closeModal} 
            isOpen={true} 
            title={"Ticket# " + this.state.outsidetktview}
            hoste={<Tform tktid={this.state.outsidetktview}></Tform>}
            size="lg"
          /> 
          : 
          <ModalForm 
            closeModal={this.closeModal} 
            isOpen={true} 
            title={"Ticket# " + this.state.outsidetktview}
            hoste={<UserTform tktid={this.state.outsidetktview}></UserTform>}
            size="lg"
          />         }




      </>
    );
  }
}

export default OutsideTKT;
